export var TextFieldInputVariants;

(function (TextFieldInputVariants) {
  TextFieldInputVariants["INPUT"] = "input";
  TextFieldInputVariants["LIST"] = "list";
})(TextFieldInputVariants || (TextFieldInputVariants = {}));